module.exports = __webpack_public_path__ + "img/rugby-football.0e95c45a.png";